/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type ReviewAssetsList_deliverableStateTypes$ref: FragmentReference;
declare export opaque type ReviewAssetsList_deliverableStateTypes$fragmentType: ReviewAssetsList_deliverableStateTypes$ref;
export type ReviewAssetsList_deliverableStateTypes = {|
  +enumValues: ?$ReadOnlyArray<{|
    +name: string,
    +description: ?string,
  |}>,
  +$refType: ReviewAssetsList_deliverableStateTypes$ref,
|};
export type ReviewAssetsList_deliverableStateTypes$data = ReviewAssetsList_deliverableStateTypes;
export type ReviewAssetsList_deliverableStateTypes$key = {
  +$data?: ReviewAssetsList_deliverableStateTypes$data,
  +$fragmentRefs: ReviewAssetsList_deliverableStateTypes$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "ReviewAssetsList_deliverableStateTypes",
  "type": "__Type",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "enumValues",
      "storageKey": null,
      "args": null,
      "concreteType": "__EnumValue",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "description",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '7ff146021601582b62875e71c5d3e84a';
module.exports = node;
